import React, { useReducer } from 'react'
import { useDispatch } from 'react-redux'

const initialState = {
  data: null,
  loading: false,
  error: null,
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'loading':
      return {
        ...state,
        loading: true,
      }
    case 'success':
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case 'error':
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case 'reset':
      return initialState
    default:
      return state
  }
}

export const useAsyncDispatch = () => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const storeDispatch = useDispatch()

  const onAsyncDispatch = async (action, ...args) => {
    dispatch({ type: 'loading' })

    try {
      const data = await storeDispatch(action(...args))

      dispatch({ type: 'success', payload: data })

      return data
    } catch (error) {
      dispatch({ type: 'error', payload: error })

      throw error
    }
  }

  const resetState = () => {
    dispatch({ type: 'reset' })
  }

  return {
    ...state,
    onAsyncDispatch,
    resetState,
  }
}
